import React from 'react';
import { trackAddToCart } from '../utils/metaPixel';
interface CTASectionProps {
  headline: string;
  subtext: string;
  buttonText: string;
}
export function CTASection({
  headline,
  subtext,
  buttonText
}: CTASectionProps) {
  const handleCTAClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    trackAddToCart();
    window.location.href = 'https://tejeyemprende.store/cart/add?id=52432487153961&quantity=1';
  };
  return <section className="w-full py-16 px-4 bg-primary/5" data-id="element-36">
      <div className="max-w-2xl mx-auto text-center" data-id="element-37">
        <p className="font-heading font-bold text-2xl md:text-3xl text-textDark mb-3" data-id="element-38">
          {headline}
        </p>
        <p className="font-body text-lg text-textLight italic mb-8" data-id="element-39">
          {subtext}
        </p>
        <a href="https://tejeyemprende.store/cart/add?id=52432487153961&quantity=1" onClick={handleCTAClick} className="inline-block w-full sm:w-auto bg-primary hover:bg-primary/90 text-white font-body font-bold text-lg px-12 py-5 rounded-full shadow-soft-lg transition-all duration-300 transform hover:-translate-y-1" data-id="element-40">
          {buttonText}
        </a>
      </div>
    </section>;
}